import type { Location, UnregisterCallback } from 'history'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import Button from 'components/uiKit/Button'
import type { MCWithParams } from 'components/uiKit/Modal'
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'components/uiKit/Modal'
import { t } from 'services/Translation'

interface IFormModalExitProps {
  unblock: UnregisterCallback
  location: Location
  // loading: boolean
  submit: () => void
  onCloseModal: () => void
}

const FormModalExit: MCWithParams<IFormModalExitProps> = ({
  onClose,
  params: { unblock, location, /* loading, */ submit, onCloseModal },
}) => {
  const history = useHistory()

  const handleSave = useCallback(async () => {
    await submit()
    unblock()
    onClose()
    onCloseModal()
    history.push(location.pathname)
  }, [onClose, submit, unblock, onCloseModal, history, location.pathname])

  const handleExit = useCallback(() => {
    unblock()
    onClose()
    onCloseModal()
    history.push(location.pathname)
  }, [unblock, onClose, onCloseModal, history, location.pathname])

  return (
    <Modal maxWidth={560} name='confirmation' title={t('form.exit.modal.title')}>
      <ModalHeader
        description={t('form.exit.modal.description')}
        title={t('form.exit.modal.title')}
      />
      <ModalBody sizeAutoCapable>
        <div />
      </ModalBody>
      <ModalFooter>
        <Button name='exit' onClick={handleExit} styleType='ghost'>
          {t('uiKit.button.exit')}
        </Button>
        <Button /* loading={loading} */ name='exitAndSave' onClick={handleSave}>
          {t('uiKit.button.saveAndExit')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormModalExit
